import { render } from "./p-button.vue?vue&type=template&id=85606082&scoped=true"
import script from "./p-button.vue?vue&type=script&lang=js"
export * from "./p-button.vue?vue&type=script&lang=js"

import "./p-button.vue?vue&type=style&index=0&id=85606082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85606082"],['__file',"src/components/p-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85606082"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85606082', __exports__)) {
    api.reload('85606082', __exports__)
  }
  
  module.hot.accept("./p-button.vue?vue&type=template&id=85606082&scoped=true", () => {
    api.rerender('85606082', render)
  })

}


export default __exports__